import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Problema() {
  const cards = [{
    title: 'El síntoma físico',
    desc: 'Te despertás en la madrugada con sensación de que el ácido sube por la garganta. El pecho arde. No podés volver a dormir.'
  }, {
    title: 'El impacto emocional',
    desc: 'Comer dejó de ser un placer. Antes de cada comida pensás: "¿Esto me va a hacer daño?" Evitás salidas, cenas, reuniones.'
  }, {
    title: 'La trampa de los medicamentos',
    desc: 'El omeprazol bloquea el ácido. Eso te alivia. Pero también destruye tu capacidad de digerir bien, creando más fermentación, más gases, más reflujo.'
  }];
  return <section id="problema" className="bg-blanco py-[100px]" data-id="element-220">
      <div className="container-custom" data-id="element-221">
        <SectionHeader eyebrow="El problema real" title={<>
              ¿Cuántos años llevás
              <br data-id="element-223" />
              viviendo con este ciclo?
            </>} theme="light" data-id="element-222" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[20px] text-gris-oscuro max-w-[700px] mx-auto mb-[60px] text-center leading-[1.8]" data-id="element-224">
          Tomás el omeprazol. Te alivia. Volvés a comer con miedo. El ardor
          regresa. Tomás otro. Y el ciclo sigue. No porque seas débil. Sino
          porque nadie te explicó qué está pasando{' '}
          <em className="italic" data-id="element-225">realmente</em> en tu cuerpo.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-[60px]" data-id="element-226">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-crema border-l-[3px] border-rojo-suave p-[28px_24px] rounded-r-[6px]" data-id="element-227">
              <strong className="text-rojo-suave block text-[14px] uppercase tracking-[1px] mb-2" data-id="element-228">
                {card.title}
              </strong>
              <p className="text-[16px] text-gris-oscuro leading-[1.8]" data-id="element-229">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        scale: 0.85,
        y: 30
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        type: 'spring',
        stiffness: 80
      }} className="font-display text-[clamp(24px,4vw,40px)] font-bold text-verde-oscuro text-center max-w-[700px] mx-auto leading-[1.3]" data-id="element-230">
          El problema no es que tenés <em className="italic" data-id="element-231">demasiado</em>{' '}
          ácido.
          <br data-id="element-232" />
          Es que tenés <em className="italic" data-id="element-233">muy poco.</em>
        </motion.p>
      </div>
    </section>;
}